import { DialogTitle } from '@radix-ui/react-dialog'
import { ScrollArea } from '@/components/ui/scroll-area'
import { Dialog, DialogContent } from '@/components/ui/dialog'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'

import LogLiveTable from './log-live-table'
// Automation recording disabled.
// Keep this sample for future restore:
// import LogRecordTable from './log-record-table'

type Props = {
  cname: string
  open: boolean
  onClose: () => void
}

export default function LogDialog({ cname, open, onClose }: Props) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogTitle />
      <DialogContent
        aria-describedby=""
        className="w-[95vw] max-w-7xl sm:max-w-7xl h-[90vh] sm:h-[85vh] md:h-[80vh] p-2 sm:p-4 md:p-6"
      >
        <ScrollArea className="h-full w-full">
          <Tabs defaultValue="live" className="p-1 sm:p-2">
            <TabsList className="w-full gap-1 sm:gap-2 h-auto flex-col sm:flex-row p-1">
              <TabsTrigger
                value="live"
                className="w-full sm:w-auto text-xs sm:text-sm py-2 px-3 sm:py-2.5 sm:px-4"
              >
                Live Logs
              </TabsTrigger>
              {/* Automation recording disabled.
                  Keep this sample for future restore:
                  <TabsTrigger
                    value="record"
                    className="w-full sm:w-auto text-xs sm:text-sm py-2 px-3 sm:py-2.5 sm:px-4"
                  >
                    Record Logs
                  </TabsTrigger>
              */}
            </TabsList>
            <TabsContent value="live" className="mt-2 sm:mt-4">
              <LogLiveTable channelName={cname} />
            </TabsContent>
            {/* Automation recording disabled.
                Keep this sample for future restore:
                <TabsContent value="record" className="mt-2 sm:mt-4">
                  <LogRecordTable cname={cname} />
                </TabsContent>
            */}
          </Tabs>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  )
}
